import React, { Component } from 'react';
import EnhancedTable from '../../components/dataTable'
import { Card, CardHeader, CardBody } from 'reactstrap'
import ClipLoader from 'react-spinners/ClipLoader'
import Modal from 'react-modal'
import { Helmet } from "react-helmet"
import { Link } from 'react-router-dom'
import './index.css'
import {
  NavbarToggler,
} from 'reactstrap';
import Postman from '../../utils/service'
import { isEmpty } from '../../common/utils'
import { connect } from 'react-redux'
import { SET_IS_FILTER_OPENED, SET_FILTER } from '../../actions/actiontypes'
import AppContext from '../../AppContext'
import SweetAlert from 'react-bootstrap-sweetalert';
import { encodeforspace, amountFormatter, showEzoicAds } from '../../utils/helper'
import Cookies from 'js-cookie';
import ReactHtmlParser from 'react-html-parser';
import dateFormat from 'dateformat'


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '350px',
    height: '200px',
    border: 0,
    padding: 33,
    borderRadius: 20
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.4)'
  }
};

const HomeNews = ({ data }) => {
  if (isEmpty(data)) return null;
  return (
    <React.Fragment>

      <div className='recent-card'>
        <div className='recent-card-head d-flex justify-content-between align-items-center'>
          <h4 id='funding-rounds' >Recent Updates</h4>
          {data[0] && <small>Last updated {dateFormat(data[0]['date'], "mm/dd/yyyy")}</small>}
        </div>
        <div className='recent-card-body col-12 d-flex justify-content-start align-items-center flex-column' style={{ paddingTop: '15px' }}>
          {
            data.map((item, index) => (

              <div key={index + 'homenews'} className="w-100 d-flex justify-content-start align-items-center recent-card-maping">

                <div className='col-1 px-0 d-flex justify-content-center align-items-center hnImage'>
                  <img src={`https://www.google.com/s2/favicons?domain=` + item.GrowjoListFull.url} />

                </div>
                <div className='col-11'>
                
                  <h4>
                    <Link key={index + 'homenews-link'} to={`/company/${encodeforspace(item.GrowjoListFull.company_name)}`} style={{ fontSize: 15, marginRight: 5 }}>
                      {item.GrowjoListFull.company_name}
                    </Link>
                  </h4>
                  {
                    item.event == 'Acquisition' && <span >
                      Acquisition ${item.amount}
                    </span>
                  }
                  {
                    item.event != 'Acquisition' && <span >
                      Funding ${item.amount}
                    </span>
                  }

                  <span className='ml-3'>
                    <i className='fa  fa-circle '></i>
                    Valuation: ${amountFormatter(item.GrowjoListFull.valuation, 1)}
                  </span>
                  <span className='ml-3'>
                    <i className='fa  fa-circle '></i>
                    Revenue ${amountFormatter(item.GrowjoListFull.estimated_revenues, 0)}
                  </span>
                  <span className='ml-3'>
                    <i className='fa  fa-circle'></i>
                    Growth {Math.round(item.GrowjoListFull.employee_growth)}%
                  </span>
                </div>
              </div>
            ))
          }
        </div>
      </div>


    </React.Fragment>
  )
}


Modal.setAppElement('#root')

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpen: false,
      state: null,
      country: null,
      page: 1,
      showExportPopUp: false,
      remainingDownloadLimit: 0,
      isPremiumUser: false,
      showExportErrorPopUp: false,
      homeNewsData: props && props.context ? props.context.homenews_data : null,
      isLoggedIn: Cookies.get('token') || Cookies.get('accessToken') ? true : false,
      homeDescription: props && props.context ? props.context.homepage_description : null,
      showAd: false
    };
  }
  selectCompany = (company, id) => {
    this.props.history.push(`/company/${company}`);
  }

  download = () => {
    this.setState({ modalIsOpen: true })
    this.props.history.push('/export_list')
  }
  openModal = () => {
    this.setState({ modalIsOpen: true });
  }
  componentDidMount() {
    this.getHomeNewsData();
    this.getHomepageDescription();
    showEzoicAds([117]);
    const page = this.props.match.params.page || 1
    this.setState({ page, showAd: true })
  }

  getHomeNewsData() {
    if (this.state.homeNewsData) {
      return false;
    }
    Postman.getHomeNewsData()
      .then(res => {
        if (res.data) {
          this.setState({ homeNewsData: res.data.data })
        }
      })
  }

  componentWillReceiveProps(nextProps) {
    const page = nextProps.match.params.page || 1
    this.setState({ page })
  }
  afterOpenModal = () => {

  }

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  }
  asideToggle = () => {
    const { isFilterOpened } = this.props
    document.body.classList.toggle('aside-menu-hidden');
    this.props.setFilterStatus(!isFilterOpened)
  }

  getHomepageDescription = () => {
    if (this.state.homeDescription) {
      return false;
    }

    Postman.getHomepageDescription()
      .then(res => {
        this.setState({ homeDescription: res.data.description })
      })
      .catch(e => {
        console.log('e', e)
      });
  }

  checkMonthlyDownloadLimit = () => {
    if (!this.state.isLoggedIn) {
      this.props.history.push(`/join`)
      return
    }
    Postman.checkMonthlyDownloadLimit(this.props.filter)
      .then(res => {
        if (res.data.isPremiumUser) {
          this.setState({ showExportPopUp: true, remainingDownloadLimit: res.data.remainingLimit, isPremiumUser: true })
        } else if (res.data.remainingLimit > 0)
          this.setState({ showExportPopUp: true, remainingDownloadLimit: res.data.remainingLimit })
        else
          this.setState({ showExportErrorPopUp: true })

      })
      .catch(e => {
        console.log('e', e)
      });
  }

  downloadCsv = () => {
    this.setState({ showExportPopUp: false })
    Postman.getCsvWithFilter(this.props.filter)
      .then(res => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export.csv');
        document.body.appendChild(link);
        link.click();
      })
      .catch(e => {
        console.log('e', e)
      });
  }
  filterByChar(e) {
    let filter = this.props.filter
    filter.name = e;
    this.setState({ page: 1 })
    this.props.setFilter(filter)

  }

  closeExportPopUp = () => {
    this.setState({ showExportPopUp: false })
  }

  closeExportErrorPopUp = () => {
    this.setState({ showExportErrorPopUp: false })
  }

  upgradeBtn = () => {
    this.props.history.push(`/schedule-demo`);
  }


  componentWillUnmount() {
    const { pathname } = this.props.history.location
    const { isFilterOpened } = this.props
    if (pathname != '/' && isFilterOpened) { this.asideToggle() }
  }
  render() {
    const YYYY = new Date().getFullYear()
    const header = `The Fastest Growing Companies w/ Contacts & Emails`
    const desc = `Indexing the world’s fastest growing companies & startups with annual revenue, competitors, number of employees, funding news, valuations, etc.`
    const title = 'Fast Company Data with Emails & Contacts: Growjo'
    const { totalCount, context } = this.props

    const exportLabel = 'Export List'

    const homeNewsData = this.state.homeNewsData
    const downloadConfirmationMsg = this.state.isPremiumUser ?
      `Want to export all below companies?` :
      `You can download ${this.state.remainingDownloadLimit} companies this month, want to continue?`;

    return (
      <div className="animated fadeIn" style={{ height: "100%" }}>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={desc} />
          <meta name="author" content="Growjo" />
        </Helmet>
        <Card className="custm-card " style={{ height: '100%', marginBottom: 0 }}>
          <SweetAlert
            warning
            showCancel
            confirmBtnText="Yes, download it!"
            confirmBtnBsStyle="primary"
            title="Are you sure?"
            onConfirm={this.downloadCsv}
            onCancel={this.closeExportPopUp}
            focusCancelBtn
            show={this.state.showExportPopUp}
          >
            {downloadConfirmationMsg}
          </SweetAlert>

          <SweetAlert
            warning
            confirmBtnText="Cancel"
            confirmBtnBsStyle="primary"
            title="Download Limit Reached!!"
            onConfirm={this.closeExportErrorPopUp}
            cancelBtnBsStyle="success"
            cancelBtnText="Upgrade"
            onCancel={this.upgradeBtn}
            focusCancelBtn
            showCancel
            show={this.state.showExportErrorPopUp}
          >
            Sorry! You have already reached your download limit for this month.
          </SweetAlert>
          <CardHeader style={{ backgroundColor: 'white', paddingTop: 0 }}>
            <div className='row'>
              <div className='col-12 col-md-7'>
                <h1 style={{ color: '#474866', fontSize: 75, fontWeight: 'bold', margin: 0 }}>Growjo</h1>
                <h2 style={{ color: '#FC8600', fontSize: 28, margin: 0, marginTop: 10, fontWeight: 'bold' }}>{header}</h2>



                <h1 style={{ fontSize: 16, color: 'rgb(55, 55, 55)', fontWeight: 'normal', padding: 10 }}>
                  {this.state.homeDescription &&
                    ReactHtmlParser(this.state.homeDescription)
                  }

                </h1>

              </div>

              <div className='col-12 col-md-5'>
                <HomeNews data={homeNewsData} />
              </div>
            </div>


          </CardHeader>
          <CardBody className="position-relative" style={{ paddingTop: '5px' }}>



            {
              (<NavbarToggler className="  download" onClick={this.asideToggle} >
                Filter:<span className="fa fa-filter"></span>
              </NavbarToggler>)
            }

            <div className="row">
              <div className='col-12 col-sm-6 order-2 order-sm-1'>
                <h4 id='full-list' >Full Growjo 10,000 List</h4>
              </div>
              <div className='col-12 col-sm-6 order-1 order-sm-2' style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {this.state.isLoggedIn && <div style={{ color: "green", marginRight: 30 }}>Results: {totalCount}</div>}
                <div style={{ color: "#20a8d8", cursor: "pointer" }} onClick={this.checkMonthlyDownloadLimit}>
                  <div className='exportBtn' ><i className='fa fa-arrow-circle-down '></i> {exportLabel}</div>
                </div>

                <div style={{ color: "#20a8d8" }} >
                  <Link to={this.state.isLoggedIn ? '/search' : '/join'} >
                    <div className='exportBtn' ><i className='fa fa-search  '></i> Search Filters</div>
                  </Link>

                </div>
              </div>
            </div>


            <div className='row'>
              <div className='col-12'>
                <EnhancedTable tableData={context} onSelectCompany={this.selectCompany} page={this.state.page} />
              </div>
              <div className='col-2'>
                {this.state.showAd && <div id="ezoic-pub-ad-placeholder-117"> </div>}
              </div>

            </div>

          </CardBody>
        </Card>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
          shouldFocusAfterRender={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={true}
        >
          <div style={{ backgroundColor: "white", fontSize: 15, textAlign: "center" }}>
            <h5>While your file is downloading...</h5>
            <span>Please check us out on <a href="https://www.producthunt.com/posts/growjo" target="_blank">Product Hunt</a></span>
            <div style={{ display: "block", marginTop: 28 }}>
              <ClipLoader
                sizeUnit={"px"}
                size={40}
                color={'grey'}
                loading={this.state.downloading}
                display={'block'}
              />
            </div>
          </div>
        </Modal>

      </div>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.filter.data,
  isFilterOpened: state.filter.isOpened,
  totalCount: state.filter.totalCount,
  auth: state.auth
})
const mapDispatchToProps = dispatch => ({
  setFilterStatus: isOpened => dispatch({ type: SET_IS_FILTER_OPENED, payload: isOpened }),
  setFilter: filter => dispatch({ type: SET_FILTER, payload: filter }),
})

const ConnectedHome = connect(mapStateToProps, mapDispatchToProps)(Home)

class HomeWrapper extends React.Component {
  render() {
    return (
      <ConnectedHome context={this.context || {}} {...this.props} />
    )
  }
}
HomeWrapper.contextType = AppContext;
export default HomeWrapper;



// WEBPACK FOOTER //
// ./client/src/views/Home/index.js